import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GLOBAL } from './global';
import { Methods } from '../shared/methods';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ManuracturerService {
  public mtds: Methods = new Methods();
  public url: string;
  public token;

  constructor(private _router: Router, private _http: HttpClient) {
    this.url = GLOBAL.url + '/mfgr/';
    this.token = JSON.parse(localStorage.getItem('token'));
    if (this.token === 'undefined') {
      this.token = null;
    }
  }

  create(json): Observable<any> {
    return this.petition(this.url + 'new', json);
  }

  update(json, id): Observable<any> {
    return this.petition(this.url + 'edit/' + id + '?page=1', json);
  }

  showOne(id): Observable<any> {
    return this.petition(this.url + 'detail/' + id + '?page=1');
  }

  showAll(): Observable<any> {
    let json;
    json = null;
    return this.petition(this.url + 'list');
  }
  showAllOpti(page:any = 1,perPage:any = 10, filtros = [] ,task:any,order:any): Observable<any> {
    const json = { sort:task, order:order };
    let url = this.url + "listopti?page=" + page + "&perpage=" + perPage;
    for (let filtro of filtros) {      
      if (filtro && filtro.value) {
        console.log(filtro.key);
        url = url + "&" + filtro.key + "=" + encodeURIComponent(filtro.value);
  
        if (filtro.type) {
          url = url + "&" + filtro.key_type + "=" + filtro.type;
        }
      }
    }
    return this.petition(url,json);
  }
  showAllLite(): Observable<any> {
    let json;
    json = null;
    return this.petition(this.url + 'listlite');
  }

  delete(id): Observable<any> {
    return this.petition(this.url + 'remove/' + id);
  }

  syncMfgr(): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this._http.get('https://www.itaderp.com/backend/bot-extraer-pos/bot-extract-mfgr.php', { headers: headers }).pipe(map(res => res));
  }

  syncMfgrAll(): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this._http.get('https://www.itaderp.com/backend/bot-extraer-pos/bot-extract-mfgr-all.php', { headers: headers }).pipe(map(res => res));
  }


  petition(url, json = null, type = null): Observable<any> {
    this.token = JSON.parse(localStorage.getItem('token'));
    let params = new HttpParams().set('authorization', this.token);

    if (json != null) {
     // json = encodeURIComponent(JSON.stringify(json));
      json = JSON.stringify(json);
      params = params.set('json', json);
    }

    if (type != null) {
      params = params.set('type', type);
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this._http.post(url, params.toString(), { headers: headers })
                    .pipe(map(res => res));
  }
}
